import React, { useState } from "react";

import { Button, Spin, message } from "antd";
// import { statusInfo } from "./Utils";
import { AgreementWrapper } from './style';
import Header from "./header";
import { getAgreement } from "../../common/fetch";


const Agreement = ({ activeTab, operatorStatusField, businessStatusField, setActiveTab, exchange }) => {

    // let currentStatus = statusInfo[0];
    // if ((operatorStatusField === 3 && businessStatusField === 3) || (operatorStatusField === 4 && businessStatusField === 4)) {
    //     currentStatus = statusInfo[operatorStatusField];
    // }

    const isSigned = exchange[0].is_signed

    const [isLoading, setIsLoading] = useState(false);

    const handleViewAgreement = async () => {
        setIsLoading(true);
        try {
            const res = await getAgreement(exchange[0].id);
            window.open(res.data.url, '_blank');
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            message.error(
                error.data.message,
                6
            );
        }
    }

    return (
        <div className="agreement-content-wrapper">
            <Spin spinning={isLoading}>
                <Header handleComplete={isSigned ? 3 : 0} img={'agreement'} activeTab={activeTab} />
                <AgreementWrapper>
                    {/* <div className={currentStatus.state === 'submitted for processing' ? 'requirement-wrapper-submit' : 'requirement-wrapper'}>
                        <h3>Requirements:</h3>
                        <div className="img-wrapper img-wrapper-operator-business">
                           
                            <div>
                                <p className="img-header img-header-operator-business font-size">Operator</p>
                                <div className="img-field img-field-operator-business d-flex">
                                    <img src={statusInfo[operatorStatusField].image.operator}
                                        className='operator-image'
                                        alt='profile' />
                                    <div className="img-content-wrapper">
                                        <div className="white-text font-size">Status:</div>
                                        <div className={`${statusInfo[operatorStatusField].className} ${statusInfo[operatorStatusField].state === 'submitted for processing' && 'header-status'}`}>{statusInfo[operatorStatusField].state}</div>
                                        <Link className="font-size" onClick={() => setActiveTab('0')}>View.</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="business-field">
                            <p className="img-header img-header-operator-business font-size">Business</p>
                            <div className="img-field img-field-operator-business d-flex">
                                <img src={statusInfo[businessStatusField].image.business}
                                    className='business-image'
                                    alt='profile' />
                                <div className="img-content-wrapper">
                                    <div className="white-text font-size">Status:</div>
                                    <div className={`${statusInfo[businessStatusField].className} ${statusInfo[businessStatusField].state === 'submitted for processing' && 'header-status'}`}>{statusInfo[businessStatusField].state}</div>
                                    <Link className="font-size" onClick={() => setActiveTab('1')}>View.</Link>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div> */}
                    <div className={''}>
                        <div className={'d-flex'}>
                            <div className="section-wrapper">
                                <h3 >Agreement document</h3>
                                <div className="agreement-document-content">After you click the view agreement button, please read and sign the agreement below. Once it is completed successfully please refresh the site see the updated status.</div>
                                <Button type="primary" className="submit-btn" onClick={() => handleViewAgreement()} disabled={isSigned}>
                                    View agreement
                                </Button>
                            </div>
                        </div>
                    </div>
                </AgreementWrapper>
            </Spin>
        </div>
    )
}

export default Agreement;